module.exports = "<i *ngIf=\"sort.child == column && sort.order == 'asc'\" class=\"material-icons top-10\">keyboard_arrow_down</i>\n<i *ngIf=\"sort.child == column && sort.order == 'desc'\" class=\"material-icons top-10\">keyboard_arrow_up</i>"


//////////////////
// WEBPACK FOOTER
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/projects/shared/sort/sort.component.html
// module id = ../../../../../src/app/projects/shared/sort/sort.component.html
// module chunks = main